import { mapState, mapActions } from "vuex";
import documentModel from "@/services/word/documentModelService";

const mixin = {
    computed: {
        ...mapState({
            documentModel: (state) => state.documentModel || documentModel.create(),
        })
    },
    methods: {
        ...mapActions({
            saveDocumentModel: "saveDocumentModel",
        })
    }
};

export default mixin;